module.exports = __webpack_public_path__ + "static/media/phone_bottom_bg.8e7844f1.png";